"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalOrderApi = require("@/api/dentalOrderApi");
var _dentalClinicApi = require("@/api/dentalClinicApi");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _auth = require("@/utils/auth");
var _orderSend = _interopRequireDefault(require("@/views/orderList/order/lists/orderSend.vue"));
var _sendCompany = _interopRequireDefault(require("@/views/orderList/order/lists/sendCompany.vue"));
var _changeReceive = _interopRequireDefault(require("@/views/orderList/order/lists/changeReceive.vue"));
var _cancelOrder = _interopRequireDefault(require("@/views/orderList/order/lists/cancelOrder.vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _axios = _interopRequireDefault(require("axios"));
var _downloadZip = require("@/utils/downloadZip");
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _default = exports.default = {
  name: 'DentalOrderList',
  components: {
    Tinymce: _Tinymce.default,
    OrderSend: _orderSend.default,
    SendCompany: _sendCompany.default,
    ChangeReceive: _changeReceive.default,
    CancelOrder: _cancelOrder.default
  },
  data: function data() {
    return {
      // 列表相关
      tableData: [],
      listLoading: false,
      total: 0,
      searchForm: {
        page: 1,
        limit: 10,
        searchType: 'orderNo',
        keyword: '',
        orderStatus: '',
        status: ''
      },
      // 状态选项
      orderStatusOptions: [{
        value: '',
        label: '全部'
      }, {
        value: 0,
        label: '已取消'
      }, {
        value: 1,
        label: '待支付'
      }, {
        value: 2,
        label: '已支付'
      }, {
        value: 3,
        label: '处理中'
      }, {
        value: 4,
        label: '已发货'
      }, {
        value: 5,
        label: '已签收'
      }, {
        value: 6,
        label: '已完结'
      }, {
        value: 7,
        label: '退款中'
      }, {
        value: 8,
        label: '退款成功'
      }, {
        value: 9,
        label: '退款失败'
      }, {
        value: 10,
        label: '拒绝退款'
      }, {
        value: 11,
        label: '已关闭'
      }, {
        value: 12,
        label: '支付失败'
      }, {
        value: 13,
        label: '向第三方下单失败'
      }, {
        value: 14,
        label: '部分退款'
      }, {
        value: 15,
        label: '售后中'
      }, {
        value: 16,
        label: '部分发货'
      }],
      appointmentStatusOptions: [{
        value: '',
        label: '全部'
      }, {
        value: -1,
        label: '预约取消'
      }, {
        value: 1,
        label: '预约中'
      }, {
        value: 2,
        label: '预约成功'
      }, {
        value: 3,
        label: '检查完成'
      }],
      // 订单详情相关
      detailDialogVisible: false,
      detailLoading: false,
      orderDetail: {},
      // 取消订单相关
      cancelDialogVisible: false,
      cancelLoading: false,
      currentOrderNo: '',
      cancelForm: {
        orderNo: '',
        cancelReason: ''
      },
      cancelRules: {
        cancelReason: [{
          required: true,
          message: '请输入取消原因',
          trigger: 'blur'
        }, {
          min: 2,
          max: 200,
          message: '长度在 2 到 200 个字符',
          trigger: 'blur'
        }]
      },
      // 预约状态对话框相关
      statusDialogVisible: false,
      statusLoading: false,
      statusForm: {
        orderNo: '',
        status: ''
      },
      statusRules: {
        status: [{
          required: true,
          message: '请选择预约状态',
          trigger: 'change'
        }]
      },
      // 修改地址相关
      addressDialogVisible: false,
      addressLoading: false,
      clinicLoading: false,
      clinicOptions: [],
      addressForm: {
        orderNo: '',
        receiverName: '',
        receiverPhone: '',
        receiverAddress: '',
        clinicId: ''
      },
      addressRules: {
        receiverName: [{
          required: true,
          message: '请输入收货人姓名',
          trigger: 'blur'
        }, {
          min: 2,
          max: 200,
          message: '长度在 2 到 200 个字符',
          trigger: 'blur'
        }],
        receiverPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3456789]\d{9}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }],
        receiverAddress: [{
          required: true,
          message: '请输入收货地址',
          trigger: 'blur'
        }],
        clinicId: [{
          required: true,
          message: '请选择预约诊所',
          trigger: 'change'
        }]
      },
      // 申请退款相关功能已移除

      // 上传检查结果相关
      resultDialogVisible: false,
      resultLoading: false,
      resultForm: {
        orderNo: '',
        result: ''
      },
      resultRules: {
        result: [{
          required: true,
          message: '请输入检查结果',
          trigger: 'blur'
        }, {
          min: 5,
          max: 500,
          message: '长度在 5 到 500 个字符',
          trigger: 'blur'
        }]
      },
      // 发货相关
      shippingDialogVisible: false,
      shippingLoading: false,
      shippingForm: {
        orderNo: '',
        companyName: '',
        trackingNumber: ''
      },
      shippingRules: {
        companyName: [{
          required: true,
          message: '请输入物流公司名称',
          trigger: 'blur'
        }],
        trackingNumber: [{
          required: true,
          message: '请输入物流单号',
          trigger: 'blur'
        }]
      },
      // 用户供应商信息
      supplierInfo: null,
      isSupplier: false
    };
  },
  created: function created() {
    this.getList();
    this.checkSupplierRole();
  },
  methods: _defineProperty(_defineProperty({
    // 检查当前用户是否为供应商
    checkSupplierRole: function checkSupplierRole() {
      try {
        var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        if (JavaInfo && JavaInfo.supplierId && JavaInfo.supplierId !== 0) {
          this.supplierInfo = JavaInfo;
          this.isSupplier = true;
          console.log('当前用户是供应商，supplierId:', JavaInfo.supplierId);
        } else {
          this.isSupplier = false;
          console.log('当前用户不是供应商');
        }
      } catch (e) {
        this.isSupplier = false;
        console.error('获取用户信息失败:', e);
      }
    },
    // 判断是否可以显示操作按钮区域
    canPerformActions: function canPerformActions(order) {
      // 供应商角色不显示操作按钮
      if (this.isSupplier) return false;

      // 管理员角色根据订单状态显示操作按钮
      return this.canCancel(order) || this.canEdit(order) || this.canUploadResult(order);
    },
    // 获取订单列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;

      // 构建查询参数
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        status: this.searchForm.status || '',
        orderStatus: this.searchForm.orderStatus || ''
      };

      // 根据搜索类型添加对应参数
      if (this.searchForm.keyword) {
        if (this.searchForm.searchType === 'orderNo') {
          params.orderNo = this.searchForm.keyword;
        } else if (this.searchForm.searchType === 'packageName') {
          params.productName = this.searchForm.keyword;
        } else if (this.searchForm.searchType === 'customerPhone') {
          params.userPhone = this.searchForm.keyword;
        }
      }
      (0, _dentalOrderApi.getDentalOrderList)(params).then(function (response) {
        // 适配后端返回的数据结构
        if (response && response.list) {
          // 确保tableData始终是数组且每项都是对象
          _this.tableData = Array.isArray(response.list) ? response.list.filter(function (item) {
            return item && _typeof(item) === 'object';
          }) : [];
          _this.total = response.total || 0;
        } else {
          _this.tableData = [];
          _this.total = 0;
        }
      }).catch(function (error) {
        console.error('获取口腔订单列表失败:', error);
        _this.$message.error('获取订单列表失败，请稍后再试');
        // 发生错误时清空数据
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    // 获取订单详情
    getOrderDetail: function getOrderDetail(orderNo) {
      var _this2 = this;
      this.detailLoading = true;
      (0, _dentalOrderApi.getDentalOrderDetail)(orderNo).then(function (response) {
        // 适配后端返回的数据结构
        if (response) {
          _this2.orderDetail = response;
        } else {
          _this2.orderDetail = {};
          _this2.$message.warning('未找到订单详情');
        }
      }).catch(function (error) {
        console.error('获取口腔订单详情失败:', error);
        _this2.$message.error('获取订单详情失败，请稍后再试');
      }).finally(function () {
        _this2.detailLoading = false;
      });
    },
    // 处理搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    // 重置搜索
    handleReset: function handleReset() {
      // 先保存原始limit值，防止重置后丢失页面大小设置
      var currentLimit = this.searchForm.limit;
      this.searchForm = {
        page: 1,
        limit: currentLimit || 10,
        searchType: 'orderNo',
        keyword: '',
        orderStatus: '',
        status: ''
      };
      this.getList();
    },
    // 处理导出
    handleExport: function () {
      var _handleExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        var loading, params, orderStatusObj, timestamp, filename, queryParams, queryString, apiUrl, token, response, contentType, blob, url, link, reader, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.$confirm('确认导出口腔订单数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 1:
              // 显示加载状态
              loading = this.$loading({
                lock: true,
                text: '正在导出数据，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.p = 2;
              // 构建导出参数，与查询参数相同
              params = _objectSpread({}, this.searchForm); // 将状态值转换为中文
              if (params.status !== undefined && params.status !== null && params.status !== '') {
                // 将状态字段改为中文名称
                params.statusName = this.getOrderStatusName(params.status);
                // 删除原始的状态值
                delete params.status;
              }

              // 将订单状态值转换为中文
              if (params.orderStatus !== undefined && params.orderStatus !== null && params.orderStatus !== '') {
                // 获取订单状态中文名称
                orderStatusObj = this.orderStatusOptions.find(function (item) {
                  return item.value == params.orderStatus;
                });
                if (orderStatusObj) {
                  params.orderStatusName = orderStatusObj.label;
                  // 删除原始的订单状态值
                  delete params.orderStatus;
                }
              }

              // 方法1：使用downloadZipWithToken直接下载
              timestamp = new Date().getTime();
              filename = "\u53E3\u8154\u8BA2\u5355\u6570\u636E_".concat(timestamp, ".xlsx"); // 构建查询参数字符串
              queryParams = new URLSearchParams();
              Object.keys(params).forEach(function (key) {
                if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                  queryParams.append(key, params[key]);
                }
              });
              queryString = queryParams.toString();
              apiUrl = "admin/dental/order/export".concat(queryString ? '?' + queryString : '');
              console.log('导出参数:', queryParams.toString());

              // 使用封装好的下载函数
              token = (0, _auth.getToken)();
              _context.n = 3;
              return _axios.default.get(_settingMer.default.apiBaseURL + apiUrl, {
                responseType: 'blob',
                headers: {
                  'Authori-zation': token
                }
              });
            case 3:
              response = _context.v;
              // 检查内容类型
              contentType = response.headers['content-type'];
              if (contentType && contentType.includes('application/vnd.ms-excel')) {
                // 是Excel文件，直接下载
                blob = new Blob([response.data], {
                  type: contentType
                });
                url = window.URL.createObjectURL(blob);
                link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
                this.$message.success('导出成功');
              } else if (contentType && contentType.includes('application/json')) {
                // 是JSON响应，需要解析获取URL
                reader = new FileReader();
                reader.onload = function (e) {
                  try {
                    var jsonResponse = JSON.parse(e.target.result);
                    if (jsonResponse.message && typeof jsonResponse.message === 'string' && jsonResponse.message.includes('http')) {
                      var fileUrl = jsonResponse.message;

                      // 创建一个隐藏的a标签用于下载
                      var _link = document.createElement('a');
                      _link.style.display = 'none';
                      _link.href = fileUrl;
                      _link.target = '_blank';
                      document.body.appendChild(_link);
                      _link.click();
                      setTimeout(function () {
                        document.body.removeChild(_link);
                      }, 100);
                      _this3.$message.success('导出成功，请在新窗口中下载文件');
                    } else {
                      _this3.$message.error(jsonResponse.message || '导出失败');
                    }
                  } catch (err) {
                    _this3.$message.error('导出失败: ' + err.message);
                  }
                };
                reader.readAsText(response.data);
              } else {
                this.$message.error('服务器返回了未知格式的数据');
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('导出订单数据失败:', _t);
              this.$message.error('导出失败: ' + (_t.message || '未知错误'));
            case 5:
              _context.p = 5;
              loading.close();
              return _context.f(5);
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t2 = _context.v;
              // 用户取消导出操作
              console.log('用户取消导出');
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6], [0, 7]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    // 处理页面大小变化
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    // 处理页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    // 处理行点击
    handleRowClick: function handleRowClick(row, column, event) {
      // 避免点击操作列时触发详情
      if (column.label !== '操作') {
        this.handleViewDetail(row);
      }
    },
    // 处理查看详情
    handleViewDetail: function handleViewDetail(row) {
      this.detailDialogVisible = true;
      this.getOrderDetail(row.orderNo);
    },
    // 处理取消订单
    handleCancelOrder: function handleCancelOrder(row) {
      this.$refs.cancelOrderRef.openInit(row.orderNo);
    },
    // 提交取消订单
    submitCancelOrder: function submitCancelOrder() {
      var _this4 = this;
      this.$refs.cancelForm.validate(function (valid) {
        if (valid) {
          _this4.cancelLoading = true;
          (0, _dentalOrderApi.cancelDentalOrder)(_this4.cancelForm).then(function () {
            _this4.$message.success('订单取消成功');
            _this4.cancelDialogVisible = false;
            _this4.getList(); // 刷新列表
          }).catch(function (error) {
            console.error('取消订单失败:', error);
            _this4.$message.error('取消订单失败，请稍后再试');
          }).finally(function () {
            _this4.cancelLoading = false;
          });
        }
      });
    },
    // 处理发送短信
    handleSendSms: function handleSendSms(row) {
      this.smsDialogVisible = true;
      this.smsForm = {
        orderNo: row.orderNo,
        templateId: '',
        content: ''
      };
    },
    // 提交发送短信
    submitSendSms: function submitSendSms() {
      var _this5 = this;
      this.$refs.smsForm.validate(function (valid) {
        if (valid) {
          _this5.smsLoading = true;
          sendAppointmentSms(_this5.smsForm).then(function () {
            _this5.$message.success('短信发送成功');
            _this5.smsDialogVisible = false;
          }).catch(function (error) {
            console.error('发送短信失败:', error);
            _this5.$message.error('短信发送失败，请稍后再试');
          }).finally(function () {
            _this5.smsLoading = false;
          });
        }
      });
    },
    // 处理更多操作
    handleMoreActions: function handleMoreActions(command, row) {
      switch (command) {
        case 'edit':
          this.handleEditAddress(row);
          break;
        case 'refund':
          this.handleRefund(row);
          break;
        case 'complete':
          this.handleCompleteOrder(row);
          break;
        case 'result':
          this.handleUploadResult(row);
          break;
      }
    },
    // 处理修改地址
    handleEditAddress: function handleEditAddress(row) {
      this.$refs.changeReceiveRef.openInit(row.orderNo);
    },
    // 提交更新地址
    submitUpdateAddress: function submitUpdateAddress() {
      var _this6 = this;
      this.$refs.addressForm.validate(function (valid) {
        if (valid) {
          _this6.addressLoading = true;
          (0, _dentalOrderApi.updateAppointmentAddress)(_this6.addressForm).then(function () {
            _this6.$message.success('地址修改成功');
            _this6.addressDialogVisible = false;
            _this6.getList(); // 刷新列表
          }).catch(function (error) {
            console.error('修改地址失败:', error);
            _this6.$message.error('地址修改失败，请稍后再试');
          }).finally(function () {
            _this6.addressLoading = false;
          });
        }
      });
    },
    // 退款申请功能已移除
    // 处理完成订单
    handleCompleteOrder: function handleCompleteOrder(row) {
      var _this7 = this;
      this.$confirm('确认将该订单标记为已完成吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dentalOrderApi.updateDentalOrderStatus)({
          orderNo: row.orderNo,
          status: 3 // 检查完成状态
        }).then(function () {
          _this7.$message.success('操作成功');
          _this7.getList(); // 刷新列表
        }).catch(function (error) {
          console.error('更新订单状态失败:', error);
          _this7.$message.error('操作失败，请稍后再试');
        });
      }).catch(function () {});
    },
    // 处理上传检查结果
    handleUploadResult: function handleUploadResult(row) {
      var _this8 = this;
      // 先设置数据，再显示对话框，避免数据渲染问题
      this.resultForm = {
        orderNo: row.orderNo,
        result: row.result || ''
      };
      // 确保组件加载后再显示对话框
      this.$nextTick(function () {
        _this8.resultDialogVisible = true;
      });
    },
    // 提交检查结果
    submitResultUpload: function submitResultUpload() {
      var _this9 = this;
      this.$refs.resultForm.validate(function (valid) {
        if (valid) {
          _this9.resultLoading = true;
          (0, _dentalOrderApi.uploadDentalResult)(_this9.resultForm).then(function () {
            _this9.$message.success('检查结果上传成功');
            _this9.resultDialogVisible = false;
            // 重置表单，避免Tinymce组件状态残留
            _this9.resultForm = {
              orderNo: '',
              result: ''
            };
            // 添加延迟，确保对话框完全关闭后再刷新列表
            setTimeout(function () {
              _this9.getList(); // 刷新列表
            }, 100);
          }).catch(function (error) {
            console.error('上传检查结果失败:', error);
            _this9.$message.error('检查结果上传失败，请稍后再试');
          }).finally(function () {
            _this9.resultLoading = false;
          });
        }
      });
    },
    // 处理对话框关闭
    handleDialogClose: function handleDialogClose() {
      // 先清除各种对话框的可见状态
      this.detailDialogVisible = false;
      this.cancelDialogVisible = false;
      this.smsDialogVisible = false;
      this.addressDialogVisible = false;
      this.resultDialogVisible = false;
      this.statusDialogVisible = false;

      // 清除表单数据，避免组件状态残留
      if (this.$refs.resultForm) {
        this.$refs.resultForm.resetFields();
      }
    },
    // 处理更改预约状态
    handleChangeStatus: function handleChangeStatus(row) {
      this.statusDialogVisible = true;
      this.statusForm = {
        orderNo: row.orderNo,
        status: row.status || ''
      };
    },
    // 提交预约状态更改
    submitStatusChange: function submitStatusChange() {
      var _this0 = this;
      this.$refs.statusForm.validate(function (valid) {
        if (valid) {
          _this0.statusLoading = true;
          (0, _dentalOrderApi.updateDentalOrderStatus)(_this0.statusForm).then(function () {
            _this0.$message.success('预约状态更新成功');
            _this0.statusDialogVisible = false;
            _this0.getList(); // 刷新列表
          }).catch(function (error) {
            console.error('更新预约状态失败:', error);
            _this0.$message.error('预约状态更新失败，请稍后再试');
          }).finally(function () {
            _this0.statusLoading = false;
          });
        }
      });
    },
    // 获取订单状态类型
    getOrderStatusType: function getOrderStatusType(status) {
      var typeMap = {
        '-1': 'info',
        // 预约取消
        1: 'warning',
        // 预约中
        2: 'success',
        // 预约成功
        3: 'primary' // 检查完成
      };
      return typeMap[status] || 'info';
    },
    // 获取订单状态名称
    getOrderStatusName: function getOrderStatusName(status) {
      var nameMap = {
        '-1': '预约取消',
        1: '预约中',
        2: '预约成功',
        3: '检查完成'
      };
      return nameMap[status] || '未知状态';
    },
    // 获取订单状态类型（用于支付状态）
    getPaymentStatusType: function getPaymentStatusType(status) {
      var typeMap = {
        0: 'info',
        // 已取消
        1: 'warning',
        // 待支付
        2: 'success',
        // 已支付
        3: 'primary',
        // 处理中
        4: 'primary',
        // 已发货
        5: 'success',
        // 已签收
        6: 'success',
        // 已完结
        7: 'danger',
        // 退款中
        8: 'info',
        // 退款成功
        9: 'danger',
        // 退款失败
        10: 'danger',
        // 拒绝退款
        11: 'info',
        // 已关闭
        12: 'danger',
        // 支付失败
        13: 'danger',
        // 向第三方下单失败
        14: 'warning',
        // 部分退款
        15: 'warning',
        // 售后中
        16: 'warning' // 部分发货
      };
      return typeMap[status] || 'info';
    },
    // 获取支付方式名称
    getPayTypeName: function getPayTypeName(type) {
      var nameMap = {
        0: '未支付',
        1: '微信支付',
        2: '福豆支付',
        3: '混合支付'
      };
      return nameMap[type] || '未知方式';
    },
    // 判断是否可以取消订单
    canCancel: function canCancel(row) {
      // 预约中的订单可以取消
      return row.status === 1;
    },
    // 判断是否可以编辑订单
    canEdit: function canEdit(row) {
      // 预约中或预约成功的订单可以编辑
      return row.status === 1 || row.status === 2;
    },
    // 退款功能已移除
    // 判断是否可以完成订单
    canComplete: function canComplete(row) {
      // 预约成功的订单可以标记为完成
      return row.status === 2;
    },
    // 判断是否可以上传检查结果
    canUploadResult: function canUploadResult(row) {
      // 检查完成的订单可以上传结果，或已有结果的订单可以修改结果
      // 且预约费用大于0才可以上传
      return row.appointmentFee > 0;
    },
    // 判断是否可以发货
    canShip: function canShip(row) {
      // 已支付的订单和部分发货状态的订单可以发货
      return [2, 3, 4, 5, 16].includes(row.orderStatus);
    },
    // 判断是否可以申请售后
    canApplyAftersale: function canApplyAftersale(row) {
      // 已支付及以后状态的订单可以申请售后
      return row.orderStatus > 1;
    },
    // 远程搜索诊所
    remoteSearchClinic: function remoteSearchClinic(query) {
      var _this1 = this;
      if (query !== '') {
        this.clinicLoading = true;
        (0, _dentalClinicApi.getDentalCityList)({
          keyword: query,
          limit: 20
        }).then(function (response) {
          _this1.clinicOptions = response.list || [];
        }).catch(function (error) {
          console.error('获取诊所列表失败:', error);
        }).finally(function () {
          _this1.clinicLoading = false;
        });
      } else {
        this.clinicOptions = [];
      }
    },
    // 设置订单随机颜色
    getRandomColorClass: function getRandomColorClass(id) {
      var colors = ['success', 'warning', 'danger', 'info', 'primary'];
      return colors[id % colors.length];
    },
    // 处理发货按钮点击
    handleShipping: function handleShipping(row) {
      // 使用主订单列表的发货组件
      this.$refs.orderSendRef.openInit({
        orderNo: row.orderNo
      });
    },
    // 提交发货信息
    submitShipping: function submitShipping() {
      var _this10 = this;
      this.$refs.shippingForm.validate(function (valid) {
        if (valid) {
          _this10.shippingLoading = true;

          // 构建发货请求参数
          var data = {
            orderNo: _this10.shippingForm.orderNo,
            deliveryCompany: _this10.shippingForm.companyName,
            deliveryNo: _this10.shippingForm.trackingNumber
          };

          // 调用发货API
          (0, _dentalOrderApi.shipDentalOrder)(data).then(function () {
            _this10.$message.success('发货成功');
            _this10.shippingDialogVisible = false;
            _this10.getList(); // 刷新列表
          }).catch(function (error) {
            console.error('发货失败:', error);
            _this10.$message.error('发货失败，请稍后再试');
          }).finally(function () {
            _this10.shippingLoading = false;
          });
        }
      });
    }
  }, "handleReset", function handleReset() {
    // 先保存原始limit值，防止重置后丢失页面大小设置
    var currentLimit = this.searchForm.limit;
    this.searchForm = {
      page: 1,
      limit: currentLimit || 10,
      searchType: 'orderNo',
      keyword: '',
      orderStatus: '',
      status: ''
    };
    this.getList();
  }), "handerAftersale", function handerAftersale() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var initInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // type: 0-创建售后
    this.$router.push({
      path: "/order/aftersale/aftersaleDetail/".concat(initInfo.aftersaleNo ? initInfo.aftersaleNo : 0, "/").concat(initInfo.orderNo ? initInfo.orderNo : 0, "/").concat(type)
    });
  })
};